import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Accordion, AccordionDetails, AccordionSummary, Checkbox, Drawer, Radio } from '@mui/material';
import { CloseButton } from 'components';
import {domainActions, tagActions} from 'store';
import {goalDataTypes, Images, tagEnums} from 'utils';
import { renderColor } from '../../../../components/tagFiltering/colors';
import { filterList } from './constants';
import { canReadTags } from 'store/tags/tag.utils';

export const SessionFilters = ({ saveFilters, savedFilters }) => {
    const { tagList, domainList } = useSelector((state) => ({
        tagList: state.tags.tagList,
        domainList: state.domains.domainList,
    }));
    const dispatch = useDispatch();
    const [openDrawer, setOpenDrawer] = useState(false);
    const [expanded, setExpanded] = useState(null);
    const [search, setSearch] = useState('');
    const [filters, setFilters] = useState({
        tag: [],
        domain: [],
        type: '',
        mode: [],
        sortBy: '',
    });
    const checkApplyDisabled = filters?.tag?.length || filters?.domain?.length || filters?.type || filters?.mode?.length;

    useEffect(() => {
        dispatch(domainActions.getDomains());
        dispatch(tagActions.getTags({ module: tagEnums.GOAL }));
    }, [dispatch]);

    const handleApply = () => {
        // if (filters?.tag?.length || filters?.domain?.length || filters?.type || filters?.mode?.length) {
        const params = {
            ...savedFilters,
            ...filters,
        };
        // params.filters = filters;
        saveFilters(params);
        closeDrawer();
        // } else {
        //     const params = {
        //         ...savedFilters,
        //     };
        //     delete params.filters;
        //     saveFilters(params);
        // }
    };

    const closeDrawer = () => {
        setOpenDrawer(false);
    };

    const handleExpand = (id) => {
        setExpanded(expanded === id ? '' : id);
        setSearch('');
    };

    const setFilterList = (name, value, type) => {
        if (type === 'array') {
            if (filters[name]?.includes(value)) {
                setFilters({
                    ...filters,
                    [name]: filters[name].filter((id) => id !== value),
                });
            } else {
                setFilters({
                    ...filters,
                    [name]: [...filters[name], value],
                });
            }
        } else {
            const params = {
                ...filters,
            };
            if (!value) {
                delete params[name];
            } else {
                params[name] = value;
            }
            setFilters(params);
        }
    };

    return (
        <div>
            <button
                onClick={() => setOpenDrawer(true)}
                className={
                    savedFilters?.domain || savedFilters?.mode || savedFilters?.tag || savedFilters?.type || savedFilters?.sortBy
                        ? 'session-header-active-btn-box'
                        : 'session-gray-action-btn-box'
                }
            >
                <img src={Images.tableSortBlue} alt="filter" />
            </button>

            <Drawer className={'session-modal-wrapper'} anchor={'right'} open={openDrawer} onClose={closeDrawer}>
                <div>
                    <div className="session-modal-header">
                        <p>Filters</p>
                        <CloseButton handleCLic={closeDrawer} />
                    </div>
                    <div className="session-modal-body">
                        <div className="session-filters-wrapper">
                            {/* The Tags section filters by the tag catalog — a read action. Drop the whole
                                accordion section for a user with neither TAG_READ nor TAG_MANAGE, whose
                                `tagList` is empty anyway. */}
                            {filterList
                                ?.filter((i) => i?.name !== 'tag' || canReadTags())
                                ?.map((i, j) => (
                                <Accordion key={j} expanded={expanded === j} onChange={() => handleExpand(j)}>
                                    <AccordionSummary>
                                        <div className="space-between">
                                            <div className="filter-info-wrapper">
                                                <img src={i?.icon} alt="icon" />
                                                <p className="form-attribute-title">{i?.title}</p>
                                            </div>
                                            <img
                                                className="down-up-icon"
                                                style={expanded === j ? { transform: 'rotate(-180deg)' } : {}}
                                                src={Images.dropDown}
                                                alt="icon"
                                            />
                                        </div>
                                    </AccordionSummary>
                                    <AccordionDetails style={{ flexDirection: 'column' }}>
                                        {i?.search && (
                                            <div className="search-for-goal-box" style={{ height: 36, width: '100%', marginBottom: 12 }}>
                                                <input
                                                    onChange={(e) => setSearch(e.target.value)}
                                                    value={search}
                                                    type="text"
                                                    placeholder="Search ..."
                                                />
                                                <button>
                                                    <img src={Images.searchIcon} alt="search" />
                                                </button>
                                            </div>
                                        )}

                                        {i?.name === 'tag' &&
                                            tagList
                                                ?.filter((item) => item?.name?.toLowerCase().includes(search.toLowerCase()))
                                                .map((item, index) => (
                                                    <div className="filter-item-wrapper" key={index}>
                                                        <Checkbox
                                                            style={{
                                                                color: filters?.tag?.includes(item?.id) ? '#347AF0' : '#D0D5DD',
                                                                padding: '0',
                                                            }}
                                                            checked={filters?.tag?.includes(item?.id)}
                                                            value={item?.id}
                                                            onChange={() => {
                                                                setFilterList('tag', item?.id, 'array');
                                                            }}
                                                        />
                                                        <div
                                                            className="created-tags"
                                                            style={{
                                                                background: renderColor(item?.color).background,
                                                                color: renderColor(item?.color).color,
                                                            }}
                                                        >
                                                            {item?.name}
                                                        </div>
                                                    </div>
                                                ))}

                                        {i?.name === 'domain' &&
                                            domainList
                                                ?.filter((item) => item?.name?.toLowerCase().includes(search.toLowerCase()))
                                                .map((item, index) => (
                                                    <div className="filter-item-wrapper" key={index}>
                                                        <Checkbox
                                                            style={{
                                                                color: filters?.domain?.includes(item?.id) ? '#347AF0' : '#D0D5DD',
                                                                padding: '0',
                                                            }}
                                                            checked={filters?.domain?.includes(item?.id)}
                                                            value={item?.id}
                                                            onChange={() => {
                                                                setFilterList('domain', item?.id, 'array');
                                                            }}
                                                        />
                                                        <div className="filter-domain-box">
                                                            <p>{item?.name}</p>
                                                        </div>
                                                    </div>
                                                ))}

                                        {i?.name === 'type' &&
                                            [
                                                { label: 'Behavior Reduction', id: 'BEHAVIOR' },
                                                { label: 'Skill Acquisition', id: 'SKILL' },
                                            ]?.map((item, index) => {
                                                return (
                                                    <div className="filter-item-wrapper space-between" key={index}>
                                                        <div className="filter-item-title">
                                                            <p>{item?.label}</p>
                                                        </div>
                                                        <Radio
                                                            value={item?.id}
                                                            checked={item?.id === filters?.type}
                                                            style={{
                                                                color: item?.id === filters?.type ? '#347AF0' : '#D0D5DD',
                                                            }}
                                                            onChange={(e) => {
                                                                setFilterList('type', e.target.value);
                                                            }}
                                                        />
                                                    </div>
                                                );
                                            })}

                                        {i?.name === 'mode' &&
                                            goalDataTypes?.map((item, index) => (
                                                <div className="filter-item-wrapper" key={index}>
                                                    <Checkbox
                                                        style={{
                                                            color: filters?.mode?.includes(item?.id) ? '#347AF0' : '#D0D5DD',
                                                            padding: '0',
                                                        }}
                                                        checked={filters?.mode?.includes(item?.id)}
                                                        value={item?.id}
                                                        onChange={() => {
                                                            setFilterList('mode', item?.id, 'array');
                                                        }}
                                                    />
                                                    <div className="filter-item-title">
                                                        <p>{item?.label}</p>
                                                    </div>
                                                </div>
                                            ))}

                                        {i?.name === 'sortBy' &&
                                            [
                                                { label: 'Name (A → Z)', id: 'nameAsc' },
                                                { label: 'Name (Z → A)', id: 'nameDesc' },
                                                { label: 'Most Trials', id: 'mostTrials' },
                                                { label: 'Least Trials', id: 'leastTrials' },
                                            ].map((item, index) => (
                                                <div className="filter-item-wrapper space-between" key={index}>
                                                    <div className="filter-item-title">
                                                        <p>{item?.label}</p>
                                                    </div>
                                                    <Radio
                                                        value={item?.id}
                                                        checked={item?.id === filters?.sortBy}
                                                        style={{
                                                            color: item?.id === filters?.sortBy ? '#347AF0' : '#D0D5DD',
                                                        }}
                                                        onChange={(e) => {
                                                            setFilterList('sortBy', e.target.value);
                                                        }}
                                                    />
                                                </div>
                                            ))}
                                    </AccordionDetails>
                                </Accordion>
                            ))}
                        </div>
                    </div>

                    <div className="filter-buttons-wrapper" style={{ gap: 4 }}>
                        <button
                            onClick={() => {
                                setFilters({
                                    tag: [],
                                    domain: [],
                                    type: '',
                                    mode: [],
                                    sortBy: '',
                                });

                                const params = {
                                    ...savedFilters,
                                };
                                delete params.tag;
                                delete params.domain;
                                delete params.type;
                                delete params.mode;
                                delete params.sortBy;
                                saveFilters(params);
                            }}
                            className="reset-all-btn"
                        >
                            Reset All
                        </button>
                        <button
                            // style={{opacity: checkApplyDisabled ? 1 : 0.5}}
                            // disabled={!checkApplyDisabled}
                            onClick={handleApply}
                            className="apply-filter-btn"
                        >
                            Apply
                        </button>
                    </div>
                </div>
            </Drawer>
        </div>
    );
};
